import { Box, Button, useMediaQuery } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Text from "./Text";
import { useTheme } from "@material-ui/styles";
import { MOBILE_WIDTH } from "../sharedKernel/AppWrapper";
import { useTranslation } from "../../../utils/hooks/useTranslation";
const buttonHeight = 35;
const visibleHeightWhenHidden = 7;

export default function MainButton({ onClick, disabled = false, ...props }) {
  const { spacing, breakpoints, customBorderRadius } = useTheme();
  const { getTextIdTranslation } = useTranslation();
  const [fixed, setFixed] = useState(false);
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const bottomPositionWhenHidden = buttonHeight - visibleHeightWhenHidden;
  const bodyPadding = spacing(2) * 2;

  const id = "mainButton";
  const mobileStyle = {
    transition: "bottom 0.4s, margin 0.4s ",
    background: "#fff",
  };

  const styleUnhidden = {
    marginTop: "0px",
    width: "100%",
    bottom: "-50px",
    pointerEvents: "inherit",
  };

  const styleHidden = {
    boxShadow: "0 0 10px 4px #fff",
    width: isScreenXs
      ? `calc(100% - ${bodyPadding * 2}px)`
      : MOBILE_WIDTH - bodyPadding * 2,
    left: "50%",
    transform: "translate(-50%, 0%)",
    position: "fixed",
    bottom: `-${bottomPositionWhenHidden}px`,
    pointerEvents: "none",
  };
  const setButtonStyle = (e) => {
    const animEventIsNotButtonContainer =
      e?.target.id !== "main-button-container";
    if (
      elementInViewport(document.getElementById(id)) &&
      animEventIsNotButtonContainer
    ) {
      setFixed(false);
    } else {
      setFixed(true);
    }
  };
  const handleClick = () => {
    setButtonStyle();
    window.scroll(0, 0);
    onClick();
  };

  useEffect(() => {
    setButtonStyle();
    window.addEventListener("scroll", setButtonStyle);
    window.addEventListener("touchmove", setButtonStyle);
    window.addEventListener("resize", setButtonStyle);
    window.addEventListener("animationend", setButtonStyle);
    return () => {
      window.removeEventListener("scroll", setButtonStyle);
      window.removeEventListener("animationend", setButtonStyle);
      window.removeEventListener("touchmove", setButtonStyle);
      window.removeEventListener("resize", setButtonStyle);
    };
  }, []);

  const mobileButtonHideStyle = fixed ? styleHidden : styleUnhidden;
  const style = { ...mobileStyle, ...mobileButtonHideStyle };

  return (
    <Box
      mt={isScreenXs ? 2 : 3}
      id={id}
      height={50}
      style={{
        width: "100%",
      }}
    >
      <Box
        style={{ ...style }}
        borderRadius={customBorderRadius.button}
        id="main-button-container"
      >
        <Button
          style={{
            width: "100%",
            height: 48,
          }}
          className="progression"
          variant="contained"
          aria-label={
            getTextIdTranslation(props.children?.props?.tId) ||
            getTextIdTranslation("CONTINUE")
          }
          color={props?.color || "primary"}
          onClick={handleClick}
          disabled={disabled}
          {...props}
        >
          {props.children || <Text tId="CONTINUE" />}
        </Button>
      </Box>
    </Box>
  );
}

function elementInViewport(el) {
  const minimumVisiblePercentageToShow = 0;
  const visibleOffsetHeight = 3;
  if (el) {
    let top = el.offsetTop;
    let height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
    }

    return (
      top >= window.pageYOffset &&
      top + visibleOffsetHeight + height * minimumVisiblePercentageToShow <=
        window.pageYOffset + window.innerHeight
    );
  }
}
